import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { CRCLastLoginReportData } from '@models/utilizationReporting/crcLastLoginReportData';
import { FullStudyUtilizationReportData } from '@models/utilizationReporting/fullStudyUtilizationReportData';
import { PatientLastRequestSubmittedAtReportData } from '@models/utilizationReporting/patientLastRequestSubmittedReportData';
import { PatientProfileCreationReportData } from '@models/utilizationReporting/patientProfileCreationReportData';
import { SiteRequestCountReportData } from '@models/utilizationReporting/siteRequestCountReportData';
import { getSiteBaseUrl } from '@utility/utility';
import { Observable } from 'rxjs';

@Injectable()
export class ReportServices {
    httpClient = inject(HttpClient);

    getStudyExpenses(studyId: number): Observable<ArrayBuffer> {
        return this.httpClient.get(`${getSiteBaseUrl()}/api/reports/study/${studyId}/expenses`, {
            responseType: 'arraybuffer',
            headers: new HttpHeaders({ 'Timezone-Offset': new Date().getTimezoneOffset() }),
        });
    }
    getFullStudyUtilizationReportData(studyId: number) {
        return this.httpClient.get<FullStudyUtilizationReportData>(
            `${getSiteBaseUrl()}/api/reports/study/${studyId}/utilizationReportData`
        );
    }
    getCRCLastLoginReportData(studyId: number) {
        return this.httpClient.get<CRCLastLoginReportData[]>(
            `${getSiteBaseUrl()}/api/reports/study/${studyId}/crcLastLoginReportData`
        );
    }
    getPatientLastRequestSubmittedAtReportData(studyId: number) {
        return this.httpClient.get<PatientLastRequestSubmittedAtReportData[]>(
            `${getSiteBaseUrl()}/api/reports/study/${studyId}/patientLastRequestSubmittedAtReportData`
        );
    }
    getSiteRequestCountReportData(studyId: number) {
        return this.httpClient.get<SiteRequestCountReportData[]>(
            `${getSiteBaseUrl()}/api/reports/study/${studyId}/siteRequestCountReportData`
        );
    }
    getPatientProfileCreationReportData(studyId: number) {
        return this.httpClient.get<PatientProfileCreationReportData[]>(
            `${getSiteBaseUrl()}/api/reports/study/${studyId}/patientProfileCreationReportData`
        );
    }
    getStipendReport(studyId: number, siteId: number | null, patientId: number | null) {
        let params: HttpParams = undefined;

        if (siteId) {
            params = new HttpParams().set('siteId', siteId);
        } else if (patientId) {
            params = new HttpParams().set('patientId', patientId);
        }

        return this.httpClient.get(`${getSiteBaseUrl()}/api/reports/study/${studyId}/stipendReport`, {
            params: params,
            responseType: 'arraybuffer',
            headers: new HttpHeaders({ 'Timezone-Offset': new Date().getTimezoneOffset() }),
        });
    }

    getPendingPaymentStipendReport(studyId: number, siteId: number | null, patientId: number | null) {
        let params: HttpParams = undefined;

        if (siteId) {
            params = new HttpParams().set('siteId', siteId);
        } else if (patientId) {
            params = new HttpParams().set('patientId', patientId);
        }

        return this.httpClient.get(`${getSiteBaseUrl()}/api/reports/study/${studyId}/pendingPaymentStipendReport`, {
            params: params,
            responseType: 'arraybuffer',
            headers: new HttpHeaders({ 'Timezone-Offset': new Date().getTimezoneOffset() }),
        });
    }
}
